var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatteryPoi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 3,
    fill: "#0000FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 3,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 33H13C12.2044 33 11.4413 32.6839 10.8787 32.1213C10.3161 31.5587 10 30.7956 10 30V18C10 17.2044 10.3161 16.4413 10.8787 15.8787C11.4413 15.3161 12.2044 15 13 15H31C31.7956 15 32.5587 15.3161 33.1213 15.8787C33.6839 16.4413 34 17.2044 34 18V30C34 30.7956 33.6839 31.5587 33.1213 32.1213C32.5587 32.6839 31.7956 33 31 33Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4469 28.5L24.6969 24H19.2969L21.5469 19.5",
    stroke: "#0000FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 19.5H35.521C35.7535 19.5 35.983 19.554 36.1915 19.659L36.9205 20.0235C37.1696 20.148 37.3792 20.3394 37.5257 20.5762C37.6722 20.8131 37.7499 21.086 37.75 21.3645V26.6355C37.7502 26.9141 37.6727 27.1872 37.5261 27.4241C37.3796 27.661 37.1698 27.8523 36.9205 27.9765L36.1915 28.341C35.9835 28.4457 35.7539 28.5001 35.521 28.5H34",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryPoi);
export default __webpack_public_path__ + "static/media/battery-poi.5616a8c93ca9df0f77ebd5fe74b4f828.svg";
export { ForwardRef as ReactComponent };